import { SC } from "../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const testimonialService = {
    getTestimonials,
    storeTestimonial,
    deleteTestimonial,
    showTestimonial,
    editTestimonial,
    approveByToken
}

function getTestimonials(brand_id, pageSize, sort, filter, is_admin) {
    return SC.getCall('testimonial', { brand: brand_id, pageSize, sort, filter, is_admin });
}

function storeTestimonial(data) {
    return SC.postCallWithoutAuth('testimonial', data);
}

function deleteTestimonial(id) {
    return SC.deleteCall(`deleteTestimonial/${pathSegment(id)}`);
}
function showTestimonial(id) {
    return SC.getCall(`testimonial/${pathSegment(id)}`);
}
function editTestimonial(id, data) {
    return SC.putCall(`testimonial/${pathSegment(id)}`, data);
}
function approveByToken(token) {
    return SC.postCallWithoutAuth(`testimonial/approve/${pathSegment(token)}`);
}
